/**
 * GoBox Image Slider - JavaScript Functionality
 * Scroll-based image transitions (front, left, back, right)
 */

(function() {
  'use strict';

  function init() {
    setupImageSliders();
  }

  /**
   * GoBox image slider - scroll-based transitions
   */
  function setupImageSliders() {
    const sliders = document.querySelectorAll('.slider-container');
    if (sliders.length === 0) return;

    sliders.forEach((slider) => {
      const images = slider.querySelectorAll('.gobox-slider-image');
      if (images.length === 0) return;

      let currentIndex = 0;

      function updateImageSlider() {
        const rect = slider.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionTop = rect.top;
        const sectionHeight = rect.height;

        // Define scroll range
        const startPoint = windowHeight * 0.8;
        const endPoint = -sectionHeight + (windowHeight * 0.2);
        const scrollRange = startPoint - endPoint;

        // Calculate progress (0 to 1)
        let progress = 0;
        if (sectionTop < startPoint && sectionTop > endPoint) {
          const scrolled = startPoint - sectionTop;
          progress = Math.max(0, Math.min(1, scrolled / scrollRange));
        } else if (sectionTop <= endPoint) {
          progress = 1;
        }

        // Map progress to image index
        // Assuming 4 images: front (0), left (1), back (2), right (3)
        let imageIndex = 0;
        const numImages = images.length;

        if (numImages === 4) {
          // Default 4-image progression
          if (progress < 0.25) {
            imageIndex = 0; // Front
          } else if (progress < 0.5) {
            imageIndex = 1; // Left
          } else if (progress < 0.65) {
            imageIndex = 2; // Back
          } else {
            imageIndex = 3; // Right
          }
        } else {
          // Generic: divide progress evenly
          imageIndex = Math.floor(progress * numImages);
          if (imageIndex >= numImages) imageIndex = numImages - 1;
        }

        // Only update if index changed
        if (imageIndex !== currentIndex) {
          currentIndex = imageIndex;

          images.forEach((img, index) => {
            const isActive = index === currentIndex;
            const isLeftOrRight = (numImages === 4) && (index === 1 || index === 3);
            
            if (isActive) {
              img.style.opacity = '1';
              img.style.transform = isLeftOrRight ? 'scale(0.75)' : 'scale(1)';
            } else {
              img.style.opacity = '0';
              img.style.transform = 'scale(0.95)';
            }
          });
        }
      }

      // Throttle scroll for performance
      let ticking = false;
      function requestTick() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateImageSlider();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick, { passive: true });
      updateImageSlider(); // Initial call
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
